import { Box, Popover, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import PersonalDetails from "./MemberDetails/PersonalDetailsView";
import PaymentVerificationView from "./MemberDetails/PaymentVerificationView";
import NomineeDetails from "./MemberDetails/NomineeDetailsView";
import EmployeeDetails from "./MemberDetails/EmployeeDetailsView";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify from "../../Helpers/ToastNotification";
import { APICall } from "../../Helpers/Network/APICalls";
import { insertIntoMemberEnrollmentHistory } from "../../Helpers/APIEndPoints/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { RiFileListLine } from "react-icons/ri";
import { makeStyles } from "@mui/styles";
import WitnessDetails from "./MemberDetails/WitnessDetailsView";
import KYCDetails from "./KYCDetails/KYCDetails";
import VerifyModal from "../Common/VerifyModal/VerifyModal";
import { Modules } from "../../Helpers/Enums/Modules";
import { loggedRoleStatus } from "../../Helpers/Enums/Enum";
import { Decrypt } from "../../Helpers/Cryptography/Crypto";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MemberVerificationView = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const location = useLocation();
  //localStorage.setItem("MemberId", state?.id);
  const [value, setValue] = React.useState(0);
  const [memberid, setMemberId] = React.useState(state?.id || "");
  const context = getContext();
  const [ShowHideButton, setShowHideButton] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);

  //const memberid = localStorage.getItem("MemberId") || "";
  const [tabsStatus, setTabsStatus] = React.useState([true, true, true, true]);
  let tabs = [
    { label: "Personal Details", value: { ...a11yProps(0) } },
    { label: "Witness Details", value: { ...a11yProps(1) } },
    { label: "Employee Details", value: { ...a11yProps(2) } },
    { label: "Nominee Details", value: { ...a11yProps(3) } },
    { label: "KYC Details", value: { ...a11yProps(4) } },
    { label: "Payment Details", value: { ...a11yProps(5) } },
  ];

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) {
        let encMemberId = params.get("memberid");
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split("||");
        setMemberId(parts[0]);
        setShowHideButton(parseInt(parts[1]));
      }
    }
  }, [location.search]);

  if (context?.loggedInAs?.value == RoleEnum.HRHOD) {
    tabs = tabs.slice(0, 5);
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectNextTab = (index: any) => {
    let val = value + 1;
    setValue(val);
    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
  };

  const selectPreviousTab = (index: any) => {
    setValue(value - 1);

    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
  };

  const HandleNextPrv = () => {
    let next = false;
    let prev = false;
    if (context?.loggedInAs?.value !== RoleEnum.HRHOD) {
      if ([5, 4, 3, 2, 1].includes(value)) {
        prev = true;
      }
      if ([4, 3, 2, 1, 0].includes(value)) {
        next = true;
      }
    } else {
      if ([4, 3, 2, 1].includes(value)) {
        prev = true;
      }
      if ([3, 2, 1, 0].includes(value)) {
        next = true;
      }
    }

    return (
      <>
        <ButtonComponent
          icon={"far fa-times-circle"}
          value={"Cancel"}
          style={{ marginLeft: "10px" }}
          className="btn btn-primary"
          onClick={() => navigate("/MemberVerification")}
        />

        {prev && (
          <ButtonComponent
            icon={"fas fa-arrow-left"}
            value={"Previous"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={selectPreviousTab}
          />
        )}
        {next && (
          <ButtonComponent
            icon={"fas fa-arrow-right"}
            value={"Next"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={selectNextTab}
          />
        )}
      </>
    );
  };

  let tabTrue = false;
  if (value === 5 && context?.loggedInAs?.value !== RoleEnum.HRHOD) {
    tabTrue = true;
  } else if (value === 4 && context?.loggedInAs?.value === RoleEnum.HRHOD) {
    tabTrue = true;
  }

  return (
    <>
      <div>
        <Box sx={{ width: "100%" }}>
          <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />

          <CustomTabPanel value={value} index={0}>
            <PersonalDetails
              selectNextTab={(index) => selectNextTab(1)}
              selectPreviousTab={selectPreviousTab}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <WitnessDetails
              selectNextTab={() => selectNextTab(2)}
              selectPreviousTab={(index) => selectPreviousTab(1)}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <EmployeeDetails
              selectNextTab={() => selectNextTab(3)}
              selectPreviousTab={(index) => selectPreviousTab(2)}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <NomineeDetails
              selectNextTab={() => selectNextTab(4)}
              selectPreviousTab={(index) => selectPreviousTab(3)}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <KYCDetails
              selectNextTab={() => selectNextTab(5)}
              selectPreviousTab={(index) => selectPreviousTab(4)}
            />
          </CustomTabPanel>
          {context?.loggedInAs?.value !== RoleEnum.HRHOD ? (
            <CustomTabPanel value={value} index={5}>
              <PaymentVerificationView
                selectNextTab={() => selectNextTab(6)}
                selectPreviousTab={(index) => selectPreviousTab(5)}
              />
            </CustomTabPanel>
          ) : (
            ""
          )}
        </Box>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <div>
          <HandleNextPrv />
          {tabTrue && ShowHideButton == 1 && (
            <ButtonComponent
              icon={"fas fa-check-double"}
              value={"Verify"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={handleClick}
            >
              
            </ButtonComponent>
          )}
        </div>
      </div>
      <>
        <VerifyModal
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          memberid={memberid}
          module={
            context?.loggedInAs?.value === RoleEnum.HRHOD
              ? Modules.RegistrationApproval
              : Modules.PaymentVerification
          }
        />
      </>
    </>
  );
};

export default MemberVerificationView;
